import { Arbeitsbereich } from '@/domain/arbeitszeiten/entities';
import { markierungMapper } from '@/utils';

export function getColorByOption(
  arbeitsbereichId: string,
  arbeitsbereiche: Arbeitsbereich[],
) {
  const arbeitsbereich = arbeitsbereiche.find(
    (a) => a.id.toLowerCase() === arbeitsbereichId,
  );
  if (!arbeitsbereich) {
    return null;
  }
  const color = markierungMapper[arbeitsbereich.markierung].base;
  return color;
}
